import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {SubCriterionParameter} from "./subCriterionParameterDomain";
// import {PROJECT_VERSION_READONLY} from "../../gridsContants";


@entityConfig()
export class SubCriterion extends DomainAncestor {

  @observable subCriterionId: number;
  @observable name: string;
  @observable code : string;
  @observable description: string;
  @observable type : SUBCRITERIONVALUESTYPE;
  @observable parameters : SubCriterionParameter[];

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.subCriterionId;
  }

  public setId(id: ID): void {
    this.subCriterionId = <number>id;
  }
}

export enum SUBCRITERIONVALUESTYPE {
  LIST = "LIST",
  SELECT = "SELECT",
  MULTISELECT = "MULTISELECT",
  INPUTS = "INPUTS",
  MATERIALS = "MATERIALS",
  ENERGY_CARRIERS = "ENERGY_CARRIERS",
  SHARED_SUBCRITERION = "SHARED_SUBCRITERION",
  AREAS = "AREAS",
  RECYCLABLE_MATERIALS_GRID = "RECYCLABLE_MATERIALS_GRID",
  EPD_CERTIFIED_MATERIALS_GRID = "EPD_CERTIFIED_MATERIALS_GRID",
  WOOD_BASED_MATERIALS_GRID = "WOOD_BASED_MATERIALS_GRID",
  AREAS_ZELPO_GRID = "AREAS_ZELPO_GRID",
  AREAS_ZELZP_GRID = "AREAS_ZELZP_GRID",
  AREAS_ZELZF_GRID = "AREAS_ZELZF_GRID",
  AREAS_ZELZS_GRID = "AREAS_ZELZS_GRID",
  AREAS_ZELST_GRID = "AREAS_ZELST_GRID",
  AREAS_VPREP_GRID = "AREAS_VPREP_GRID",
  AREAS_PEFKE_GRID = "AREAS_PEFKE_GRID",
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/criterion/subCriterionDomain.ts